import { AppRoute } from "./app-routes";
import common from "../i18n/definitions/common";

export const saavutettavuusselosteRoutes = {
  categories: [
    {
      anchor: "Saavutettavuusseloste",
      components: [
        {
          anchor: "Link",
          name: "SitemapLink",
          properties: {
            route: AppRoute.Saavutettavuusseloste,
            text: common.saavutettavuusseloste
          }
        }
      ]
    }
  ]
};
